<template>
  <div class="hp_commuEditorWrap">
    <editor
      v-model="content"
      api-key="kzj2jdtduql44vtgurqnrj4otlx3bkvkiznzk18tvm41yrcj"
      :init="editorInit"
      class="hp_commuEditorBox"
    />
  </div>
</template>

<script>
/* eslint-disable camelcase */
import {
  insert_editor_image
} from '../ETC/Axios.vue'

export default {
  props: ['value'],
  data () {
    return {
      content: this.value,
      editorInit: {
        height: 900,
        menubar: true,
        language: 'ko_KR',
        fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
        plugins: [
          'advlist autolink lists link image charmap preview',
          'anchor searchreplace visualblocks code fullscreen',
          'insertdatetime media table wordcount'
        ],
        toolbar:
          'undo redo | bold italic strikethrough underline forecolor backcolor | ' +
          'fontsizeselect | alignleft aligncenter alignright alignjustify | ' +
          'image removeformat help | custom_toggle',
        branding: false,
        placeholder: '내용을 입력하세요.',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        images_upload_handler: async (blobInfo, success, failure) => {
          try {
            const data = await insert_editor_image(blobInfo)
            const imageUrl = data
            success(imageUrl)
          } catch (e) {
            console.error(e)
            failure(e.message)
          }
        }
      }
    }
  },
  watch: {
    value (newValue) {
      this.content = newValue
    },
    content (newContent) {
      this.$emit('input', newContent)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ETC/CustomTextarea.vue